export default function () {

  function loadSpinner() {
    
  }
  loadSpinner();
}